'use client';

import React from 'react';

import { useDrawerStore } from '@/stores';

import { PrintPolicyDrawer } from '../PrintPolicyDrawer';

type PrintPolicyDrawerConfigProps = {
  privacyPolicy: string;
  title?: string;
};

const createPrintPolicyDrawerConfig = (config: PrintPolicyDrawerConfigProps) => ({
  title: config.title || 'Política de Privacidade',
  Component: () => React.createElement(PrintPolicyDrawer, config),
  drawerType: 'print-policy',
  drawerOptions: {
    snapPoints: [0.9, 0.95],
    fadeFromIndex: 0,
  },
});

export const usePrintPolicyDrawer = () => {
  const openDrawer = useDrawerStore((state) => state.openDrawer);
  const replaceDrawer = useDrawerStore((state) => state.replaceDrawer);
  const drawers = useDrawerStore((state) => state.drawers);

  const openPrintPolicyDrawer = (config: PrintPolicyDrawerConfigProps) => {
    const drawerConfig = createPrintPolicyDrawerConfig(config);
    const hasOpenDrawer = drawers.length > 0;

    if (hasOpenDrawer) {
      replaceDrawer(drawerConfig);
    } else {
      openDrawer(drawerConfig);
    }
  };

  return { openPrintPolicyDrawer };
};
